import type { ReactNode } from 'react';
import clsx from 'clsx';
import { PageProgress } from './PageProgress';

export interface LoadingBoundaryProps {
  children?: ReactNode;
  loading: boolean;
  hasData?: boolean;
  error?: ReactNode;
  fallback?: ReactNode;
  className?: string;
}

/** Presentation-only loading boundary for feature page content. */
export function LoadingBoundary({ children, loading, hasData = false, error, fallback, className }: LoadingBoundaryProps) {
  const isInitialLoading = loading && !hasData;

  return (
    <div className={clsx('vania-loading-boundary', className)} aria-busy={loading || undefined}>
      <PageProgress active={loading} />
      {isInitialLoading ? <div className="vania-loading-reserved" aria-hidden="true" /> : null}
      {error && !isInitialLoading ? <div className="vania-async-state vania-async-state-error" role="alert">{error}</div> : null}
      {!isInitialLoading ? children : null}
    </div>
  );
}
